<template>
    <div>
      <FilterTable 
        :resource_name="resource_name"
        :title="title"
        :field_definitions="field_definitions"
        :filters="{}"
        :action_buttons="action_buttons"
        :row_actions="row_actions"
        :translate_to_display_data="translate_to_display_data"
        :route_root="route_root"
        :handle_row_action="handle_row_action"
        :full_text_search="true"
        :handle_action_button_click="handle_action_button_click"
        :update_flag="filter_table_update_flag"
      />
      <el-dialog
        title="新增主題"
        :visible.sync="dialog_visible"
        width="30%"
        center>
        <EditViewForm 
          :handle_dynamic_form_update="handle_dynamic_form_update"
          :page_structure="page_structure"
          mode="add"
        />
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="handle_save_button_click">確定</el-button>
        </span>
      </el-dialog>

      <el-dialog title="設定開放時間" :visible="is_open" :append-to-body="true" @close="handleClose" :boolean="false">
        <RadioWithDatePicker
          :publish_setting="metadata.publish_setting"
          :options="options"
          :update:start_date="metadata.start_date"
          :update:end_date="metadata.end_date"
          :handle_dynamic_form_update="handle_dynamic_form_update"
        />
        <div slot="footer" class="dialog-footer">
          <!-- <el-button @click="isOpen = false">取 消</el-button> -->
          <el-button type="primary" @click="save_theme_open_time()">確 定</el-button>
        </div>
      </el-dialog>
    </div>
    
</template>

<script>
import breadcrumbMixin from '@/mixins/breadcrumbMixin'
import FilterTable from '@/components/backstage/FilterTable/FilterTable.vue'
import EditViewForm from '@/components/backstage/EditViewForm/EditViewForm.vue'
import RadioWithDatePicker from '@/components/backstage/RadioWithDatePicker/RadioWithDatePicker'
import EditStructure from '@/views/backstage/structure/theme_management/ThemeManagementAddPageStructure'
import axios from 'axios'

  export default {
    mixins: [breadcrumbMixin],
    components: {
      FilterTable,
      EditViewForm,
      RadioWithDatePicker
    },
    created () {
      this.permission_check({
        resource_info: { name: this.page_name.PAGE_THEME_MANAGEMENT },
        access: { name: this.permission.VIEW },
        reject: { action: this.permission.REJECT_REDIRECT, path: '/dashboard' }
      })
    },
    data() {
      return {
        resource_name: 'theme',
        title: '主題專區管理',
        route_root: 'front-stage-management/theme-management',
        dialog_visible: false,
        page_structure: [],
        metadata: {},
        field_definitions: [
          {
            display: {
              name: '名稱',
              type: 'string',
              sortable: 'custom',
            },
            source: {
              type: 'db',
              key: 'theme_title',
              data_type: 'string',
            } 
          },
          {
            display: {
              name: '公告日期',
              type: 'string',
              sortable: 'custom',
            },
            source: {
              type: 'db',
              key: 'opening_time_start',
              data_type: 'datetime',
            }
          },
          {
            display: {
              name: '下架日期',
              type: 'string',
              sortable: 'custom',
            },
            source: {
              type: 'db',
              key: 'opening_time_end',
              data_type: 'datetime',
            }
          },
          {
            display: {
              name: '自動/排程',
              type: 'string',
              sortable: 'custom',
            },
            source: {
              type: 'db',
              key: 'opening_mode',
              data_type: 'string',
            }
          },
          {
            display: {
              name: '上次編輯時間',
              type: 'string',
              sortable: 'custom',
            },
            source: {
              type: 'db',
              key: 'updated_time',
              data_type: 'datetime',
            }
          },
          {
            display: {
              name: '建立者',
              type: 'string',
              sortable: 'custom',
            },
            source: {
              type: 'db',
              key: 'creator',
              data_type: 'string',
            }
          },
          {
            display: {
              name: '編輯狀態',
              type: 'string',
              sortable: 'custom',
            },
            source: {
              type: 'db',
              key: 'opening_status',
              data_type: 'string',
            }
          },
        ],
        action_buttons: {
          add: {
            label: '新增主題',
            action: 'add'
          },
        },
        row_actions: {
          suspend: {
            label: '下架',
            action: 'suspend',
            enable: (row) => (row['opening_status'] === '已開放')
          },
          resume: {
            label: '開放',
            action: 'resume',
            enable: (row) => (row['opening_status'] !== '已開放')
          },
          get: {
            label: '編輯',
            action: 'edit'
          },
          delete: {
            label: '刪除',
            action: 'delete',
          },
        },
        loading: false,
        filter_table_update_flag: 0,
        options: [
          {
            value: "手動",
            label: "立即公告",
          },
          {
            value: "排程",
            label: "公告日期",
          }
        ],
        is_open: false,
        current_theme_id: ''
      }
    },
    methods: {
      init () {

        this.page_structure = EditStructure('add_page')

        let metadata_temp = this.forge_context_container(this.page_structure)
      },
      handle_row_action (action, index, row) {

          switch(action){
            case 'edit': 
                this.backstage_router_push({ path: `/${this.route_root}/theme/edit/${row.id}` })
                break
            case 'suspend': 
                // 下架 (已開放)
                this.handle_theme_status('suspend', row.id)
                break
            case 'resume': 
                // 開放 (草稿)
                this.handle_theme_status('resume', row.id)
                break
            case 'delete': 
                this.handle_theme_delete(row.id)
                break
            default:
                break
          }
      },
      handle_action_button_click (action) {
        console.log('ThemeManagementPage: action button clicked: ', action)

        switch(action){
          case 'add': 
            this.dialog_visible = true
            this.init()
            // this.backstage_router_push({ path: `/${this.route_root}/theme/add` })
            break
          case 'export': 
              break
          default:
              break
        }
      },
      handle_save_button_click() {
        this.dialog_visible = false

        let theme_title = this.metadata.theme_title
        axios.post(process.env.VUE_APP_API_BACKSTAGE_URL +'/theme/add', {theme_title: theme_title})
          .then((response) => {
            let theme_id = response.data.payload.id
            this.backstage_router_push({ path: `/${this.route_root}/theme/edit/${theme_id}` })
          })
          .catch(err => {
              console.log(err)
          })

        
      },
      handle_dynamic_form_update (key, form_value) {
        console.log('ThemeManagementPage: handle_dynamic_form_update:' + key + ', value:', form_value)

        this.$set(this.metadata, key, form_value)
      },
      handleClose(){
        this.is_open = false
      },
      handle_theme_status (status, index){
        if(status === 'resume'){
          this.is_open = true
          this.current_theme_id = index
        }else{
          this.current_theme_id = index

          this.$confirm('是否確定下架所選主題', '下架主題', {
            confirmButtonText: '確定',
            cancelButtonText: '取消',
            type: 'info'
          }).then(() => {

            let api_obj = {
              id: this.current_theme_id,
              opening_mode: '手動',
              opening_manual_switch: 0
            }

            axios.post(process.env.VUE_APP_API_BACKSTAGE_URL +'/theme/offline', api_obj)
              .then((response) => {
                if(response.data.code === 200){
                  this.$message({
                    type: 'success',
                    message: '下架成功!'
                  });
                  this.filter_table_update_flag += 1
                }
              })
              .catch(err => {
                  console.log(err)
              })

            


          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消下架'
            });
            this.filter_table_update_flag += 1
          });
        }
      },
      save_theme_open_time(){
        console.log("metadata: ", this.metadata);
        console.log(this.current_theme_id)

        let api_obj = {}
        if(this.metadata.publish_setting === '手動'){
          api_obj = {
            id: this.current_theme_id,
            opening_mode: this.metadata.publish_setting,
            opening_manual_switch: 1
          }
        }else if(this.metadata.publish_setting === '排程'){
          api_obj = {
            id: this.current_theme_id,
            opening_mode: this.metadata.publish_setting,
            opening_time_start: this.metadata.start_date,
            opening_time_end:  this.metadata.end_date,
          }
          if(this.metadata.start_date===undefined || this.metadata.start_date===null) {
            this.notify_message(this.ERROR.LEVEL.WARN, '預定上架日期為必填', '')
            return
          }
        }

        axios.post(process.env.VUE_APP_API_BACKSTAGE_URL +'/theme/online', api_obj)
          .then((response) => {
            if(response.data.code === 200){
              this.$message({
                type: 'success',
                message: '此主題已開放!'
              });
              this.filter_table_update_flag += 1
              this.handleClose()
            }
          })
          .catch(err => {
              console.log(err)
          })
      },
      handle_theme_delete(index){

        this.$confirm('是否確定刪除所選主題', '刪除主題', {
            confirmButtonText: '確定',
            cancelButtonText: '取消',
            type: 'info'
          }).then(() => {
            axios.post(process.env.VUE_APP_API_BACKSTAGE_URL +'/theme/delete', {id: index})
              .then((response) => {
                if(response.data.code === 200){
                  this.$message({
                    type: 'success',
                    message: '刪除成功!'
                  });
                  this.filter_table_update_flag += 1
                }
              })
              .catch(err => {
                  console.log(err)
              })
          }).catch(() => {
            // debugger
            this.$message({
              type: 'info',
              message: '已取消刪除'
            });          
          });

      }
    }
  };
</script>

<style>
</style>
